import { QRCodeSVG } from "qrcode.react";
import { naira } from "@/lib/api";
import { Logo } from "@/components/Logo";

export function ClaimVoucher({ data }) {
  const b = data.beneficiary;
  const active = (data.vouchers || []).filter((v) => v.status === "active");
  return (
    <div data-testid="claim-voucher-print" className="claim-voucher bg-white text-emerald-950 border-2 border-emerald-600 rounded-2xl p-6 max-w-xl mx-auto">
      <div className="flex items-center justify-between border-b-2 border-emerald-100 pb-3">
        <Logo />
        <div className="text-right">
          <div className="text-[10px] font-mono uppercase tracking-widest text-emerald-700">TMF-ID Claim Voucher</div>
          <div className="text-[10px] text-gray-500">Issued: {new Date(data.issue_date).toLocaleDateString()}</div>
        </div>
      </div>

      <div className="mt-4 flex gap-5">
        <div className="w-24 h-28 rounded-xl bg-emerald-50 border border-emerald-200 flex items-center justify-center text-emerald-400 text-xs text-center shrink-0">
          {b.photo ? <img src={b.photo} alt="beneficiary" className="w-full h-full object-cover rounded-xl" /> : "PHOTO"}
        </div>
        <div className="flex-1">
          <div className="text-xs text-gray-500">Beneficiary Name</div>
          <div className="font-display font-bold text-lg">{b.full_name || "—"}</div>
          <div className="mt-2 grid grid-cols-2 gap-2 text-sm">
            <div><div className="text-xs text-gray-500">TMF ID</div><div className="font-mono font-semibold text-emerald-700">{b.tmf_id}</div></div>
            <div><div className="text-xs text-gray-500">Phone</div><div className="font-mono">{b.phone}</div></div>
            <div><div className="text-xs text-gray-500">State / LGA</div><div>{b.state || "—"} {b.lga ? `/ ${b.lga}` : ""}</div></div>
            <div><div className="text-xs text-gray-500">Security Ref</div><div className="font-mono text-xs">{data.security_ref}</div></div>
          </div>
        </div>
        <div className="text-center shrink-0">
          <QRCodeSVG value={data.qr_payload} size={96} fgColor="#064E3B" />
          <div className="text-[9px] text-gray-400 mt-1">Scan to verify</div>
        </div>
      </div>

      <div className="mt-4">
        <div className="text-xs font-mono uppercase tracking-widest text-emerald-700 mb-1">Active Programme Vouchers</div>
        {active.length === 0 && <div className="text-sm text-gray-500">No active vouchers.</div>}
        {active.map((v) => (
          <div key={v.code} className="flex justify-between items-center text-sm border-b border-gray-100 py-1.5">
            <div>
              <span className="font-mono font-bold text-emerald-800">{v.tmf_voucher_id || v.code}</span>
              <span className="block text-[10px] text-gray-400 font-mono">{v.code}</span>
            </div>
            <span className="font-semibold text-emerald-700">{naira(v.balance)}</span>
          </div>
        ))}
      </div>

      <p className="mt-4 text-[10px] leading-relaxed text-gray-500 bg-emerald-50 rounded-lg p-2 border border-emerald-100">
        TMF-ID CLAIM VOUCHER — THE DIGITAL RECORD REMAINS THE PRIMARY SOURCE OF ENTITLEMENT. This printout is a convenience credential linked to the beneficiary's core TMF profile; balances are held centrally in the TMF ledger.
      </p>
    </div>
  );
}
